import { useQuery } from 'react-query';

import { getPoapSecondaryViews as queryFn } from 'api/endPoints/getPoapSecondaryViews';
import { QueryKeys } from 'api/queryKeys';

export const GET_POAP_SECONDARY_VIEWS_QUERY_KEY: QueryKeys = 'getPoapSecondaryViews' as const;

export const useQueryGetPoapSecondaryViews = (params: QueryParams) => {
    return useQuery<QueryFnResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: [GET_POAP_SECONDARY_VIEWS_QUERY_KEY, params],
        queryFn: () => queryFn({ customerId: params.customerId }),
        enabled: Boolean(params.customerId) && Boolean(params.username),
        select: (response) => {
            return response.map((view) => {
                return {
                    ...view,
                    isOwner: view.viewOwner === params.username,
                };
            });
        },
    });
};

export interface QueryParams {
    customerId: number | undefined;
    username: string | undefined;
}

interface PoapView {
    hidden: boolean;
    public: boolean;
    viewId: number;
    viewName: string;
    viewOrder: number;
    viewOwner: string;
}

interface PoapViewResponse extends PoapView {
    isOwner: boolean;
}

type QueryFnResponse = PoapView[];

type QueryResponse = PoapViewResponse[];
